// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FacultyPublications_faculty-publications__NpSYw {
  display: flex;
  flex-direction: column;
}
.FacultyPublications_faculty-publications__NpSYw .FacultyPublications_publication__ThjJz {
  margin-bottom: 25px;
}
.FacultyPublications_faculty-publications__NpSYw .FacultyPublications_publication__ThjJz .FacultyPublications_coauthors__iYtUA {
  margin-bottom: 3px;
  color: var(--dark-grey);
}
.FacultyPublications_faculty-publications__NpSYw .FacultyPublications_publication__ThjJz .FacultyPublications_coauthors__iYtUA span {
  margin-right: 10px !important;
  font-style: italic;
}
.FacultyPublications_faculty-publications__NpSYw .FacultyPublications_publication__ThjJz .FacultyPublications_title__ArNsy {
  margin-bottom: 3px;
}
.FacultyPublications_faculty-publications__NpSYw .FacultyPublications_publication__ThjJz .FacultyPublications_title__ArNsy .FacultyPublications_paper-title__RnB5l {
  font-weight: bold;
  cursor: pointer;
}
.FacultyPublications_faculty-publications__NpSYw .FacultyPublications_publication__ThjJz .FacultyPublications_title__ArNsy .FacultyPublications_paper-title__RnB5l:hover {
  text-decoration: underline;
  color: var(--blue);
}
.FacultyPublications_faculty-publications__NpSYw .FacultyPublications_publication__ThjJz .FacultyPublications_title__ArNsy .FacultyPublications_venue__HcdVL {
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyDetail/Components/FacultyPublications/FacultyPublications.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,kBAAA;EACA,uBAAA;AACN;AACM;EACE,6BAAA;EACA,kBAAA;AACR;AAGI;EACE,kBAAA;AADN;AAGM;EACE,iBAAA;EACA,eAAA;AADR;AAIM;EACE,0BAAA;EACA,kBAAA;AAFR;AAKM;EACE,kBAAA;AAHR","sourcesContent":[".faculty-publications {\n  display: flex;\n  flex-direction: column;\n\n  .publication {\n    margin-bottom: 25px;\n\n    .coauthors {\n      margin-bottom: 3px;\n      color: var(--dark-grey);\n\n      span {\n        margin-right: 10px !important;\n        font-style: italic;\n      }\n    }\n\n    .title {\n      margin-bottom: 3px;\n\n      .paper-title {\n        font-weight: bold;\n        cursor: pointer;\n      }\n\n      .paper-title:hover {\n        text-decoration: underline;\n        color: var(--blue);\n      }\n\n      .venue {\n        font-style: italic;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faculty-publications": `FacultyPublications_faculty-publications__NpSYw`,
	"publication": `FacultyPublications_publication__ThjJz`,
	"coauthors": `FacultyPublications_coauthors__iYtUA`,
	"title": `FacultyPublications_title__ArNsy`,
	"paper-title": `FacultyPublications_paper-title__RnB5l`,
	"venue": `FacultyPublications_venue__HcdVL`
};
export default ___CSS_LOADER_EXPORT___;
